import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d0953f06&scoped=true&"
import script from "./miniCourse.ts?vue&type=script&lang=ts&"
export * from "./miniCourse.ts?vue&type=script&lang=ts&"
import style0 from "./miniCourse.css?vue&type=style&index=0&id=d0953f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0953f06",
  null
  
)

export default component.exports